// Iter-200j — Visual hint shown below the reminder template textarea that
// tells the CEO exactly WHERE the "Déclarer le paiement de cette facture"
// CTA banner will be injected. Mirrors the regex used by both
// `lib/payment_cta_banner.py` (backend) and `_injectBannerBeforeSignoff`
// in ManualReminderDialog.jsx (frontend mirror).
import React from "react";
import { Sparkles, AlertTriangle } from "lucide-react";
import { detectSignoffLine } from "@/lib/signoffDetector";

export default function CTAInsertionHint({ text, compact = false }) {
  const hit = detectSignoffLine(text || "");
  if (hit) {
    return (
      <div
        className={`flex items-start gap-2 ${compact ? "text-[10px]" : "text-[11px]"} text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-md px-2.5 py-1.5 leading-snug`}
        data-testid="cta-insertion-hint-detected"
      >
        <Sparkles size={11} className="shrink-0 mt-0.5" />
        <div>
          <span className="font-semibold">Bannière CTA insérée ici&nbsp;↓</span>{" "}
          juste avant la ligne&nbsp;
          <span className="font-mono bg-white px-1 rounded border border-emerald-200">
            « {hit.line.length > 50 ? hit.line.slice(0, 50) + "…" : hit.line} »
          </span>
          {" "}(L.{hit.lineNumber})
        </div>
      </div>
    );
  }
  return (
    <div
      className={`flex items-start gap-2 ${compact ? "text-[10px]" : "text-[11px]"} text-amber-700 bg-amber-50 border border-amber-200 rounded-md px-2.5 py-1.5 leading-snug`}
      data-testid="cta-insertion-hint-fallback"
    >
      <AlertTriangle size={11} className="shrink-0 mt-0.5" />
      <div>
        <span className="font-semibold">Aucune formule de politesse détectée</span> — la bannière CTA sera ajoutée à la fin du corps.{" "}
        <span className="text-amber-600">Astuce&nbsp;:</span> terminez par <span className="font-mono">Cordialement,</span> ou <span className="font-mono">— BAIM</span> pour la positionner avant la signature.
      </div>
    </div>
  );
}
